import React from "react";
import Classes from "classnames";

import FormFieldFormElementProto from "../../form-element-proto";
import Input from 'core/gd-form/form-element/input/input';

class NumberField extends FormFieldFormElementProto {

    constructor(props) {
        super(props);

        this._bind('onChange');

        this.state = {
            value: props.value,
            invalidValue: false,
            // isEditing: false
        };

    }

    onChange(newValue) {

        if (!newValue) newValue = '';

        this.setState({
            value: newValue,
            invalidValue: !(_.isNil(newValue) || !isNaN(newValue) || newValue.length === 0)
        },()=>{
            if (this.props.onChange) this.props.onChange(newValue)
        });

    }

    render() {

        const classes = Classes('gd-form-field-number', 'form-element', {
            'invalid-value': this.state.invalidValue
        });

        return (

            <div className={classes}>

                <Input size="big" form={this.props.form} name={this.props.name} onChange={this.onChange} />

            </div>

        );
    }

}

// StringField.propTypes = props;
// StringField.defaultProps = defaultProps;

export default function renderNumberFormFieldFormElement(field, props) {
    return <NumberField field={field} {...props} />;
}